(() => {
  if (window.ZZStorefrontV04Loaded) return;
  window.ZZStorefrontV04Loaded = true;

  const params = new URLSearchParams(window.location.search);
  const previewThemeId = params.get('preview_theme_id') || (window.Shopify?.theme?.role !== 'main' ? window.Shopify?.theme?.id : null);
  const locale = params.get('zz_lang') === 'zh' ? 'zh' : 'en';
  const isZh = locale === 'zh';
  document.body.dataset.locale = locale;
  document.documentElement.lang = isZh ? 'zh-CN' : 'en';

  document.querySelectorAll('[data-en][data-zh]').forEach((node) => {
    node.textContent = node.dataset[locale];
  });

  document.querySelectorAll('[data-preserve-locale]').forEach((link) => {
    if (!isZh && !previewThemeId) return;
    const url = new URL(link.href, window.location.origin);
    if (isZh) url.searchParams.set('zz_lang', 'zh');
    if (previewThemeId) url.searchParams.set('preview_theme_id', previewThemeId);
    link.href = `${url.pathname}${url.search}${url.hash}`;
  });

  const productMenu = document.querySelector('[data-products-menu]');
  if (productMenu) {
    document.addEventListener('click', (event) => {
      if (productMenu.open && !productMenu.contains(event.target)) productMenu.open = false;
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') productMenu.open = false;
    });
  }

  const filterButtons = document.querySelectorAll('[data-catalog-filter]');
  const homeCards = document.querySelectorAll('[data-zz-home] [data-product-grid] .product-card');
  filterButtons.forEach((button) => button.addEventListener('click', () => {
    filterButtons.forEach((item) => item.setAttribute('aria-selected', String(item === button)));
    const key = button.dataset.catalogFilter;
    homeCards.forEach((card) => { card.hidden = key !== 'all' && card.dataset.category !== key; });
  }));

  const catalogRoot = document.querySelector('[data-zz-catalog-root]');
  if (catalogRoot) {
    const productKey = params.get('zz_product');
    const productPdp = productKey ? catalogRoot.querySelector(`[data-textile-pdp="${CSS.escape(productKey)}"]`) : null;
    const catalogView = catalogRoot.querySelector('[data-catalog-view]');
    if (productPdp) {
      catalogView.hidden = true;
      productPdp.hidden = false;
      const title = productPdp.querySelector('.pdp-buy h1')?.textContent?.trim();
      if (title) document.title = `${title} – ZEKZEK`;
    } else {
      const categories = {
        all: { en: 'All products', zh: '所有商品' },
        acrylic: { en: 'Acrylic', zh: '亚克力' },
        paper: { en: 'Paper goods', zh: '纸制品' },
        textiles: { en: 'Textiles', zh: '纺织品' },
        apparel: { en: 'Apparel', zh: '衣服' }
      };
      const key = Object.hasOwn(categories, params.get('zz_category')) ? params.get('zz_category') : catalogRoot.dataset.collectionHandle === 'paper-goods' ? 'paper' : 'all';
      const cards = [...catalogRoot.querySelectorAll('[data-product-grid] .product-card')];
      const visibleCards = cards.filter((card) => key === 'all' || card.dataset.category === key);
      cards.forEach((card) => { card.hidden = !visibleCards.includes(card); });
      catalogRoot.querySelector('[data-catalog-title]').textContent = categories[key][locale];
      catalogRoot.querySelector('[data-catalog-count]').textContent = isZh ? `${visibleCards.length} 件商品` : `${visibleCards.length} ${visibleCards.length === 1 ? 'product' : 'products'}`;
      catalogRoot.querySelectorAll('[data-category-link]').forEach((link) => {
        if (link.dataset.categoryLink === key) link.setAttribute('aria-current', 'page');
        else link.removeAttribute('aria-current');
      });
    }
  }

  document.querySelectorAll('[data-pdp-gallery]').forEach((gallery) => {
    const image = gallery.querySelector('[data-pdp-main-image]');
    const buttons = gallery.querySelectorAll('[data-pdp-media-src]');
    buttons.forEach((button) => button.addEventListener('click', () => {
      buttons.forEach((item) => item.setAttribute('aria-pressed', String(item === button)));
      image.src = button.dataset.pdpMediaSrc;
      image.alt = button.dataset.pdpMediaAlt;
    }));
  });

  document.querySelectorAll('[data-textile-pdp]').forEach((pdp) => {
    const options = pdp.querySelectorAll('[data-size-id]');
    const summary = pdp.querySelector('[data-size-readout-summary]');
    const detail = pdp.querySelector('[data-size-readout-detail]');
    const updateReadout = (option) => {
      if (summary) summary.textContent = option.getAttribute(`data-size-summary-${locale}`);
      if (detail) detail.textContent = option.getAttribute(`data-size-detail-${locale}`);
    };
    options.forEach((option) => option.addEventListener('click', () => {
      options.forEach((item) => item.setAttribute('aria-pressed', String(item === option)));
      updateReadout(option);
    }));
    if (options[0]) updateReadout(options[0]);
  });

  const revealItems = document.querySelectorAll('.reveal');
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches || !('IntersectionObserver' in window)) {
    revealItems.forEach((item) => item.classList.add('is-visible'));
  } else {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (!entry.isIntersecting) return;
        entry.target.classList.add('is-visible');
        observer.unobserve(entry.target);
      });
    }, { threshold: 0.12 });
    revealItems.forEach((item) => observer.observe(item));
  }
})();
